import React, { useEffect } from 'react';
import Chart, { Props as ApexProps } from 'react-apexcharts';

import { ChartWrapper } from '../../../components/Charts/ChartWrapper';
import { preprocessData } from '../utils/preprocessData';
import { useAppSelector } from '../../../../../store';
import { useLazyGetPostsQuery } from '../service/posts.api';
import { selectAnalyticsFilters } from '../../../store/analyticFiltersSlice';

export const PostsSimpleLineChart = () => {
    const filters = useAppSelector(selectAnalyticsFilters);

    const colors = ['#D6E4FF', '#ADC6FF', '#85A5FF', '#597EF7'];

    const [
        getPosts,
        {
            data: messages = {
                total_messages: 0,
                posts: [],
            },
            isFetching,
            isLoading,
        },
    ] = useLazyGetPostsQuery();

    useEffect(() => {
        if (filters) {
            const payload = {
                ...filters,
                community_id: filters.chat,
            };
            getPosts(payload, true);
        }
    }, [filters]);

    const chartData = preprocessData(messages?.posts);

    const options: ApexProps['options'] = {
        chart: {
            toolbar: {
                show: false,
            },
        },
        legend: {
            show: true,
            position: 'left',
        },

        plotOptions: {
            heatmap: {
                radius: 5,
            },
        },
        colors: colors,
        markers: {
            colors: colors,
        },
        xaxis: {
            categories: chartData.dates,
        },
    };

    return (
        <ChartWrapper isLoading={isFetching || isLoading} title='Сообщения'>
            <Chart
                height={'200px'}
                type='line'
                options={options}
                series={[
                    {
                        name: 'Количество сообщений',
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        data: chartData.counts,
                    },
                ]}
            />
        </ChartWrapper>
    );
};
